<template>
  <div class="animated fadeIn personPage">
    <div v-if="!user.id">
      <p>User not found, or you do not have access to this user in the given Org/Group context.</p>
    </div>

    <h2 v-show="updateUserPending" class="u-padding-bottom-20">Updating, please wait ...</h2>
    <pulse-loader :loading="updateUserPending" :color="spinnerColor" :size="spinnerSize"></pulse-loader>

    <div v-if="user.id && !updateUserPending">
      <b-form @submit="addOrUpdateUserRecord">
        <b-row class="mb-4" align-h="between">
          <b-col cols="auto">
            <h4 class="card-title mb-0">{{ user.fullName }}</h4>
            <div class="small text-muted">Added {{ getUserAddedDate() }}</div>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm='12'>
            <UserForm :addUser="false" :formUser="user" v-on:addOrUpdate="addOrUpdateUserRecord"></UserForm>

             <b-alert
              fade
              :show="updateUserFailure"
              :variant="'danger'">
              <span v-html="apiResponseMessage(updateUserFailure)">
              </span>
            </b-alert>

          </b-col>
        </b-row>
      </b-form>
    </div>
  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  import UserForm from '@/views/t1/Admin/UserForm'

  export default {
    name: 'edituser',
    components: {
      UserForm
    },
    computed: {
      ...mapGetters({
        user: 'getEditUser',
        updateUserPending: 'updateUserPending',
        updateUserFailure: 'updateUserFailure',
        updateUserSuccess: 'updateUserSuccess'
      }),
      userId () {
        return this.$route.params.id
      }
    },
    data: function () {
      return {
        spinnerColor: '#0F347B',
        spinnerSize: '50px'
      }
    },
    watch: {
      updateUserSuccess: function (newValue) {
        if (newValue) {
          // Send them back to the view user screen
          this.$router.push({ path: '/admin/users/' })
        }
      }
    },
    methods: {
      addOrUpdateUserRecord (user) {
        let updatedData = _.pick(user, [
          'emailAddress',
          'password',
          'isSuperAdmin',
          'isCseitTrained',
          'active',
          'isRemoved'
        ])
        updatedData.primaryOrganization = user.primaryOrganization
        updatedData.fullName = user.fullName

        // Filter out empty strings
        updatedData = _.pickBy(updatedData, (value) => {
          return value !== ''
        })

        this.$validator.validate().then(result => {
          if (result) {
            this.$store.dispatch('updateUser', { id: this.userId, data: updatedData })
          }
        })
      },
      getUserAddedDate: function () {
        const user = this.user

        if (user.createdAt) {
          return this.$utils.unixToHuman(user.createdAt / 1000)
        }
        return 'unknown'
      },
      apiResponseMessage: function () {
        let message = ''
        if (this.updateUserFailure) {
          message = this.$utils.errorToHtml(this.updateUserFailure)
        }

        return '<p>' + message + '</p>'
      }
    },
    async created () {
      await this.$store.dispatch('getUserForEdit', { id: this.userId })
    },
    beforeDestroy: function () {
      this.$store.commit('resetEditUser')
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/t1/Admin/EditUser.vue